module.exports = __webpack_public_path__ + "img/Joel_Braithwaite.6ad7727b.jpg";